<template>
  <div>
    <v-dialog
      v-model="showChequeRequisitionForm"
      scrollable
      max-width="800"
      persistent
    >
      <cheque-requisition-form
        :option="chequeRequisitionReportOption"
        v-on:save="showChequeRequisitionForm = false"
        v-on:cancel="
          chequeRequisitionReportOption.IncludeChequeRequisition = false;
          showChequeRequisitionForm = false;
        "
        :dialog="showChequeRequisitionForm"
      />
    </v-dialog>
    <v-form ref="form">
      <v-row>
        <v-col cols="auto" xs12 sm6 md4 lg4 v-if="isPremiums">
          <trans-multi-select2
            v-model="selected.InsuranceCarriers"
            :items="insuranceCarriers"
            :label="$t('globals.insurance_carrier')"
            :rules="[$rules.required]"
            field="Name"
            itemValue="Id"
            :displayFunc="(item, str) => `${str} (${item.PolicyNumber})`"
            :canSelectAll="true"
            class="required"
          ></trans-multi-select2>
        </v-col>
        <v-col cols="auto" xs12 sm6 md4 lg4 v-if="isBilling">
          <trans-multi-select2
            v-model="selected.Employers"
            :items="employers"
            :label="$t('globals.employers')"
            :rules="[$rules.required]"
            field="Name"
            itemValue="IdentityId"
            :canSelectAll="true"
            class="required"
          ></trans-multi-select2>
        </v-col>
        <v-col cols="xs12 sm6" v-if="isBilling && hasStores">
          <trans-multi-select2
            v-model="selected.Stores"
            :items="stores"
            :label="$t('globals.stores')"
            field="Name"
            itemValue="IdentityId"
            :canSelectAll="true"
          ></trans-multi-select2>
        </v-col>
        <v-col cols="auto" xs12 sm6 md4 lg4 v-if="isRemittances">
          <trans-multi-select2
            v-model="selected.TrustFunds"
            :items="trustFunds"
            :label="$t('components.getreports.trust_fund')"
            field="Name"
            itemValue="Id"
            :canSelectAll="true"
          ></trans-multi-select2>
        </v-col>
        <v-col cols="auto" xs12 sm6 md4 lg4 v-if="hasCoverageGroupItems">
          <trans-multi-select2
            v-model="selected.CoverageGroups"
            :items="coverageGroupItems"
            :label="$t('components.getreports.coverage_groups')"
            field="Name"
            itemValue="Name"
            :canSelectAll="true"
          ></trans-multi-select2>
        </v-col>
        <v-col
          cols="auto"
          class="align-self-center"
          v-if="shouldShowPlanSummary"
        >
          <v-checkbox
            v-model="includeTotal"
            :label="$t('components.getreports.include_plan_summary')"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <table class="report-options">
          <tr v-for="(option, i) in options" :key="i">
            <td class="align-self-center">
              <h3>{{ option.Name }}</h3>
            </td>
            <td
              cols="auto"
              class="align-self-center"
              v-if="!isBilling || !option.EmployerHasStores"
            >
              <v-checkbox
                v-model="option.IncludeMemberDetails"
                :label="$t('components.getreports.include_member_details')"
              ></v-checkbox>
            </td>
            <td
              cols="auto"
              class="align-self-center"
              v-if="isBilling && !option.EmployerHasStores"
            >
              <v-checkbox
                v-model="option.IncludeGroupSummary"
                :label="$t('components.getreports.include_group_summary')"
              ></v-checkbox>
            </td>
            <td cols="auto" class="align-self-center" v-if="isPremiums">
              <v-checkbox
                v-model="option.IncludeGroupSummary"
                :label="
                  $t('components.getreports.include_coverage_summary_group')
                "
              ></v-checkbox>
            </td>
            <td
              cols="auto"
              class="align-self-center"
              v-if="
                option.InsuranceCarrierId &&
                  option.InsuranceCarrierId !==
                    '00000000-0000-0000-0000-000000000000'
              "
            >
              <v-checkbox
                v-model="option.IncludeTotal"
                :label="$t('components.getreports.include_carrier_summary')"
              ></v-checkbox>
            </td>
            <td
              cols="auto"
              class="align-self-center"
              v-if="
                option.EmployerId &&
                  option.EmployerId !==
                    '00000000-0000-0000-0000-000000000000' &&
                  option.EmployerHasStores
              "
            >
              <v-checkbox
                v-model="option.IncludeTotal"
                :label="$t('components.getreports.include_stores_summary')"
              ></v-checkbox>
            </td>
            <td cols="auto" class="align-self-center" v-if="isRemittances">
              <v-checkbox
                v-model="option.IncludeGroupSummary"
                :label="
                  $t('components.getreports.include_coverage_summary_group')
                "
              ></v-checkbox>
            </td>
            <td cols="auto" class="align-self-center" v-if="isRemittances">
              <v-checkbox
                v-model="option.IncludeTotal"
                :label="$t('components.getreports.include_trustfund_total')"
              ></v-checkbox>
            </td>
            <td cols="auto" class="align-self-center" v-if="isPremiums">
              <v-checkbox
                v-model="option.IncludeChequeRequisition"
                @change="onChequeChange(option)"
                :label="
                  $t(
                    'components.getreports.include_chequepayment_requisition_form'
                  )
                "
              ></v-checkbox>
            </td>
          </tr>
        </table>
      </v-row>
      <v-row>
        <v-col cols="auto" class="align-self-center">
          <v-btn
            :disabled="!isReportSelectionValid"
            :loading="isLoadingReport"
            dark
            color="success"
            @click="tryGetReport()"
          >
            {{ $t("components.getreports.get") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <report-display
      v-if="showReportDisplay"
      :file="report"
      :pdfFileLink="pdfFileLink"
    />
    <error-handler :error="error" />
  </div>
</template>

<script>
import ReportDisplay from "./ReportDisplay.vue";
import { mapGetters, mapActions } from "vuex";
import ErrorHandler from "@/components/ErrorHandler";
import TransMultiSelect2 from "@/components/TransMultiSelect2";
import ChequeRequisitionForm from "@/components/ChequeRequisitionForm";
import ReportOptions from "./ReportOptions";
import { translate2 } from "../../trans2";
import { sortAlphanum } from "@/alphanumericSort";

const GUID_EMPTY = "00000000-0000-0000-0000-000000000000";

export default {
  name: "report-form",
  props: {
    reportParameters: { type: Object, default: () => ({}) },
    reportOptions: { type: Array, default: () => [] },
    reportType: { type: String, required: true },
    term: { type: Object, required: true },
    reportId: { type: String, required: true },
  },
  components: {
    ErrorHandler,
    ChequeRequisitionForm,
    ReportDisplay,
    TransMultiSelect2,
  },
  async mounted() {
    try {
      console.log("mounting starting", this.mounting);
      if (this.isPremiums) {
        await this.loadInsuranceCarriers();
      } else if (this.isBilling) {
        await this.loadEmployers();
        // await this.loadStores(this.employers[0].Id);
      } else if (this.isRemittances) {
        await this.loadTrustFunds();
      }
      await this.loadCoverageGroups();
      this.includeTotal = this.reportParameters.IncludeTotal;

      // console.log("report options", this.options);

      // this.payload = {
      //   Options: this.options,
      //   PlanId: this.plan.Id,
      //   TermId: this.term.Id,
      //   IncludeTotal: this.reportParameters.IncludeTotal || false,
      //   HasAdminFees: this.reportParameters.HasAdminFees || false,
      //   HasCommissions: this.reportParameters.HasCommissions || false,
      //   HasContributions: this.reportParameters.HasContributions || false,
      //   HasPaymentTracking: this.reportParameters.HasPaymentTracking || false,
      //   HasRemittances: this.reportParameters.HasRemittances || false,
      //   TracksMembersActivity:
      //     this.reportParameters.TracksMembersActivity || false,
      //   CoverageGroups: this.selected.CoverageGroups.map((scg) => {
      //     return scg.Name;
      //   }),
      //   ReportType: this.reportType,
      //   ReportId: this.reportId,
      // };

      await this.mapOptionsToSelections(this.reportOptions);
      if (this.hasCoverageGroupItems) {
        this.mapPayloadToCoverageGroups(this.reportParameters.CoverageGroups);
      }
      this.loadOptions();
      this.isReportSelectionValid = this.checkForValidReportSelection();
    } catch (error) {
      error.messageParams = [this.reportType];
      this.error = error;
    }
    this.$nextTick(() => {
      this.mounting = false;
      console.log("mounting finished", this.mounting);
    });
  },
  data() {
    return {
      includeTotal: false,
      mounting: true,
      options: [],
      payload: {},
      error: null,
      pdfFileLink: null,
      report: null,
      showReportDisplay: false,
      showChequeRequisitionForm: false,
      chequeRequisitionReportOption: null,
      isLoadingReport: false,
      isReportSelectionValid: false,
      insuranceCarriers: [],
      employers: [],
      stores: [],
      trustFunds: [],
      coverageGroupItems: [],
      coverageGroups: [],
      selected: {
        Employers: [],
        TrustFunds: [],
        Stores: [],
        InsuranceCarriers: [],
        CoverageGroups: [],
      },
    };
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    ...mapGetters("common", ["plan", "settings", "brokerId", "language"]),
    ...mapGetters("plansMembers", ["planOptions"]),
    // selectedOptions() {
    //   if (this.isBilling) {
    //     var employers = this.options.filter((opt) => {
    //       return this.selected.Employers.some((e) => e.Id === opt.EmployerId);
    //     });
    //     var stores = this.options.filter((opt) => {
    //       return this.selected.Stores.some((s) => s.Id === opt.StoreId);
    //     });
    //     return stores.concat(employers);
    //   } else if (this.isPremiums) {
    //     return this.options.filter((opt) => {
    //       return this.selected.InsuranceCarriers.some(
    //         (ic) => ic.Id === opt.InsuranceCarrierId
    //       );
    //     });
    //   } else if (this.isRemittances) {
    //     return this.options.filter((opt) => {
    //       return this.selected.TrustFunds.some(
    //         (tf) => tf.Id === opt.TrustFundId
    //       );
    //     });
    //   }
    //   return [];
    // },
    shouldShowPlanSummary() {
      switch (this.reportType) {
        case "Premiums":
          return this.insuranceCarriers && this.insuranceCarriers.length > 1;
        case "Billing":
          return this.employers && this.employers.length > 0;
        case "Remittances":
          return this.trustFunds && this.trustFunds.length > 1;
        default:
          return false;
      }
    },
    isPremiums() {
      return this.isReportType("Premiums") && this.planOptions.HasPremiums;
    },
    isBilling() {
      return this.isReportType("Billing") && this.planOptions.HasBilling;
    },
    isRemittances() {
      return (
        this.isReportType("Remittances") && this.planOptions.HasRemittances
      );
    },
    hasEmployers() {
      return this.employers.length > 0;
    },
    hasTrustFunds() {
      return this.trustFunds.length > 0;
    },
    hasInsuranceCarriers() {
      return this.insuranceCarriers.length > 0;
    },
    hasStores() {
      return this.stores.length > 0;
    },
    hasCoverageGroupItems() {
      return this.coverageGroupItems && this.coverageGroupItems.length > 0;
    },
  },
  watch: {
    coverageGroups: {
      handler(v) {
        this.coverageGroupItems = v.map((cg) => {
          return { Name: cg };
        });
      },
      deep: true,
    },
    "selected.InsuranceCarriers": {
      async handler(v) {
        if (this.mounting) {
          return;
        }
        if (v && v.length > 0) {
          const d = new Date();
          console.log("options-1");
          this.options = v.map((i) => {
            return {
              DateOfRequest: this.toUtcString(d),
              Name: translate2(i, "Name"),
              InsuranceCarrierName: translate2(i, "Name"),
              InsuranceCarrierId: i.Id,
              User: this.user,
              IncludeMemberDetails: true,
              IncludeGroupSummary: true,
              IncludeTotal: true,
              IncludeChequeRequisition: true,
            };
          });
          await this.getCoverageGroups();
        } else {
          this.coverageGroupItems = [];
          this.options = [];
        }
      },
      deep: true,
    },
    "selected.TrustFunds": {
      async handler(v) {
        if (this.mounting) {
          return;
        }
        if (v) {
          console.log("options-2");
          this.options = v.map((i) => {
            return {
              Name: translate2(i, "Name"),
              TrustfundId: i.Id,
              User: this.user,
              IncludeMemberDetails: true,
              IncludeGroupSummary: true,
              IncludeTotal: true,
            };
          });
          await this.getCoverageGroups();
        } else {
          this.coverageGroupItems = [];
          this.options = [];
        }
      },
      deep: true,
    },
    "selected.CoverageGroups": {
      handler(v) {
        if (this.mounting) {
          return;
        }
        this.isReportSelectionValid = this.checkForValidReportSelection();
      },
      deep: true,
    },
    "selected.Employers": {
      async handler(v) {
        if (this.mounting) {
          return;
        }
        if (v && v.length > 0) {
          if (this.planOptions.ReportsPerStore) {
            this.selected.Stores = [];
            let stores = (await this.getReportEmployerStores({
              planId: this.plan.Id,
              reportId: this.reportId,
              employerId: v[0].IdentityId,
            })).data.value;

            const collator = new Intl.Collator(undefined, {
              numeric: true,
              sensitivity: "base",
            });
            if (stores.length > 0) {
              this.stores = stores.sort(collator.compare);
              this.selected.Stores = this.stores;
            } else {
              this.stores = [];
            }
          }
          console.log("options-3");
          await this.mapEmployersToPayloadOptions(v);
          await this.getCoverageGroups();
        } else {
          this.coverageGroupItems = [];
          this.stores = [];
          await this.mapEmployersToPayloadOptions(v);
        }
      },
      deep: true,
    },
    "selected.Stores": {
      async handler(v, old) {
        if (this.mounting) {
          return;
        }
        console.log("options-4");
        await this.mapStoresToPayloadOptions(v, old);
      },
      deep: true,
    },
    // payload: {
    //   handler() {
    //     this.isReportSelectionValid = this.checkForValidReportSelection();
    //   },
    //   deep: true,
    // },
  },
  methods: {
    ...mapActions("data", ["fetchFile"]),
    ...mapActions("plansMembers", [
      "getInsuranceCarriersWithReports",
      "getReportTrustFund",
      "getEmployersWithReports",
      "getStores",
      "getReportEmployerStores",
    ]),
    ...mapActions("transactions", [
      "getReport",
      "getInsuranceCarrierCoverageGroups",
      "getTrustfundCoverageGroups",
      "getPlanCoverageGroups",
    ]),
    async getCoverageGroups() {
      this.selected.CoverageGroups = [];
      if (this.reportType === "Premiums") {
        if (
          this.selected.InsuranceCarriers &&
          this.selected.InsuranceCarriers.length > 0
        ) {
          this.coverageGroups = (await this.getInsuranceCarrierCoverageGroups({
            planId: this.plan.Id,
            reportId: this.reportId,
            insuranceCarrierIds: this.selected.InsuranceCarriers.map(
              (o) => o.Id
            ),
          })).data;
        } else {
          this.coverageGroups = [];
        }
      } else if (this.reportType === "Billing") {
        this.coverageGroups = (await this.getPlanCoverageGroups({
          planId: this.plan.Id,
          reportId: this.reportId,
        })).data;
      } else if (this.reportType === "Remittances") {
        this.coverageGroups = (await this.getTrustfundCoverageGroups({
          planId: this.plan.Id,
          reportId: this.reportId,
        })).data;
      }
    },
    async mapOptionsToSelections(reportOptions) {
      console.log("map options started");
      if (this.isPremiums) {
        this.mapOptionsToInsuranceCarriers(reportOptions);
      } else if (this.isBilling) {
        await this.mapOptionsToEmployersAndStores(reportOptions);
      } else if (this.isRemittances) {
        this.mapOptionsToTrustFund(reportOptions);
      }
      console.log("map options completed");
    },
    mapOptionsToInsuranceCarriers(reportOptions) {
      this.selected.InsuranceCarriers = [];
      for (let reportOption of reportOptions) {
        if (reportOption.InsuranceCarrierId !== GUID_EMPTY) {
          const insuranceCarrier = this.insuranceCarriers.find(
            (insuranceCarrier) =>
              insuranceCarrier.Id === reportOption.InsuranceCarrierId
          );
          this.selected.InsuranceCarriers.push(insuranceCarrier);
        }
      }
    },
    async mapOptionsToEmployersAndStores(reportOptions) {
      this.selected.Employers = [];
      this.selected.Stores = [];

      let orderedOptions = reportOptions.sort((a, b) => {
        if (a.EmployerId !== GUID_EMPTY) {
          return -1;
        } else if (b.EmployerId !== GUID_EMPTY) {
          return 1;
        } else {
          return 0;
        }
      });
      console.log("sorted: ", orderedOptions);

      for (let reportOption of orderedOptions) {
        if (reportOption.EmployerId !== GUID_EMPTY) {
          const employer = this.employers.find(
            (employer) => employer.IdentityId === reportOption.EmployerId
          );
          if (employer !== null && employer !== undefined) {
            this.selected.Employers.push(employer);
            if (this.planOptions.ReportsPerStore) {
              let stores = (await this.getReportEmployerStores({
                planId: this.plan.Id,
                reportId: this.reportId,
                employerId: employer.IdentityId,
              })).data.value;
              this.stores = this.stores.concat(stores);
            }
          }
        }
        if (this.hasStores && reportOption.StoreId !== GUID_EMPTY) {
          if (this.planOptions.ReportsPerStore) {
            let store = this.stores.find(
              (o) => o.IdentityId === reportOption.StoreId
            );
            if (store !== null && store !== undefined) {
              this.selected.Stores.push(store);
            }
          }
        }
      }

      console.log(
        JSON.stringify(this.selected.Employers),
        JSON.stringify(this.selected.Stores)
      );
      console.log(JSON.stringify(this.employers), JSON.stringify(this.stores));
    },
    mapOptionsToTrustFund(reportOptions) {
      this.selected.TrustFunds = [];
      for (let reportOption of reportOptions) {
        if (reportOption.TrustFundId !== GUID_EMPTY) {
          this.selected.TrustFunds.push(
            this.trustFunds.find((o) => o.Id === reportOption.TrustFundId)
          );
        }
      }
    },
    mapPayloadToCoverageGroups(items) {
      console.log(items);
      if (items === null || items === undefined) {
        this.selected.CoverageGroups = [];
      } else {
        this.selected.CoverageGroups = this.coverageGroupItems.filter(
          (o) => items.filter((e) => e === o.Name).length > 0
        );
      }
    },
    async mapEmployersToPayloadOptions(v) {
      this.options = [];

      for (const i of v) {
        let stores = (await this.getReportEmployerStores({
          planId: this.plan.Id,
          reportId: this.reportId,
          employerId: i.IdentityId,
        })).data.value;
        var employerHasStores =
          this.planOptions.ReportsPerStore && stores
            ? stores.length > 0
            : false;
        if (
          this.options.filter((o) => o.EmployerId === i.IdentityId).length === 0
        ) {
          this.options.push({
            Name: translate2(i, "Name"),
            EmployerId: i.IdentityId,
            User: this.user,
            EmployerHasStores: employerHasStores,
          });
          if (employerHasStores) {
            this.options[this.options.length - 1].IncludeTotal = true;
          } else {
            this.options[this.options.length - 1].IncludeGroupSummary = true;
            this.options[this.options.length - 1].IncludeMemberDetails = true;
          }
        }
      }
      if (v.length === 0) {
        this.selected.Stores = [];
      }
    },
    mapStoresToPayloadOptions(v, old) {
      if (v && v.length > 0) {
        const options = v.map((i) => {
          return {
            Name: translate2(i, "Name"),
            StoreId: i.IdentityId,
            User: this.user,
            IncludeMemberDetails: true,
            IncludeGroupSummary: true,
          };
        });
        this.mapEmployersToPayloadOptions(this.selected.Employers);
        this.options = this.options.concat(options);
      } else {
        if (old.length > 0 && v.length === 0) {
          this.mapEmployersToPayloadOptions(this.selected.Employers);
        }
      }
    },
    onChequeChange(option) {
      this.chequeRequisitionReportOption = option;
      this.showChequeRequisitionForm = option.IncludeChequeRequisition;
    },
    async tryGetReport() {
      this.showReportDisplay = false;
      this.isLoadingReport = true;
      // this.options = this.selectedOptions;

      this.payload = {
        Options: this.options,
        PlanId: this.plan.Id,
        TermId: this.term.Id,
        IncludeTotal: this.reportParameters.IncludeTotal || false,
        HasAdminFees: this.reportParameters.HasAdminFees || false,
        HasCommissions: this.reportParameters.HasCommissions || false,
        HasContributions: this.reportParameters.HasContributions || false,
        HasPaymentTracking: this.reportParameters.HasPaymentTracking || false,
        HasRemittances: this.reportParameters.HasRemittances || false,
        TracksMembersActivity:
          this.reportParameters.TracksMembersActivity || false,
        CoverageGroups: this.selected.CoverageGroups.map((scg) => {
          return scg.Name;
        }),
        ReportType: this.reportType,
        ReportId: this.reportId,
      };

      try {
        const res = await this.getReport({
          entity: this.reportType.toLowerCase(),
          payload: this.payload,
        });
        this.report = res.data;
        this.showReportDisplay = true;
        this.pdfFileLink = `${this.settings.APIURL}pdfs/${this.report.PDFName}`;

        this.$nextTick(() => {
          document.getElementById("report-div").scrollIntoView({
            behavior: "smooth",
          });
        });
      } catch (error) {
        error.messageParams = [this.reportType];
        this.error = error;
      }

      this.isLoadingReport = false;
    },
    loadOptions() {
      console.log("load options started");
      if (this.reportOptions.length > 0) {
        if (this.isBilling) {
          this.options = this.reportOptions.filter(
            (o) =>
              this.employers.filter((e) => e.IdentityId === o.EmployerId)
                .length > 0 ||
              this.stores.filter((e) => e.IdentityId === o.StoreId).length > 0
          );
        } else if (this.isPremiums) {
          this.options = this.reportOptions.filter(
            (o) =>
              this.insuranceCarriers.filter(
                (e) => e.Id === o.InsuranceCarrierId
              ).length > 0
          );
        } else if (this.isRemittances) {
          this.options = this.reportOptions.filter(
            (o) =>
              this.trustFunds.filter((e) => e.Id === o.TrustfundId).length > 0
          );
        }
        // return;
      }
      console.log("load options completed", this.options);

      // if (this.isBilling) {
      //   this.options = this.stores
      //     .map((s) => {
      //       const opts = new ReportOptions();
      //       opts.StoreId = s.Id;
      //       opts.Name = s.Name;
      //       opts.User = this.user;
      //       return opts;
      //     })
      //     .concat(
      //       this.employers.map((e) => {
      //         const opts = new ReportOptions();
      //         opts.EmployerId = e.Id;
      //         opts.Name = e.Name;
      //         opts.User = this.user;
      //         return opts;
      //       })
      //     );
      // } else if (this.isPremiums) {
      //   this.options = this.insuranceCarriers.map((ic) => {
      //     const opts = new ReportOptions();
      //     opts.InsuranceCarrierId = ic.Id;
      //     opts.InsuranceCarrierName = ic.Name;
      //     opts.Name = ic.Name;
      //     opts.User = this.user;
      //     return opts;
      //   });
      // } else if (this.isRemittances) {
      //   this.options = this.trustFunds.map((tf) => {
      //     const opts = new ReportOptions();
      //     opts.TrustFundId = tf.Id;
      //     opts.Name = tf.Name;
      //     opts.User = this.user;
      //     return opts;
      //   });
      // }
    },
    async loadInsuranceCarriers() {
      let res = await this.getInsuranceCarriersWithReports({
        planId: this.plan.Id,
        reportId: this.reportId,
      });
      this.insuranceCarriers = res.data;
    },
    async loadEmployers() {
      const res = await this.getEmployersWithReports({
        planId: this.plan.Id,
        reportId: this.reportId,
      });
      this.employers = res.data.value.sort((a, b) => {
        const translatedA = a.Translations.filter(
          (o) => o.LanguageCode === this.language.language
        )[0].Name;
        const translatedB = b.Translations.filter(
          (o) => o.LanguageCode === this.language.language
        )[0].Name;
        console.log(translatedA, translatedB);
        return sortAlphanum(translatedA, translatedB);
      });
    },
    async loadStores(employerId) {
      const res = await this.getReportEmployerStores({
        planId: this.plan.Id,
        reportId: this.reportId,
        employerId: employerId,
      });

      const stores = res.data.value;
      const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: "base",
      });
      if (stores.length > 0) {
        this.stores = stores.sort(collator.compare);
      } else {
        this.stores = [];
      }
    },
    async loadTrustFunds() {
      const res = await this.getReportTrustFund({
        planId: this.plan.Id,
        reportId: this.reportId,
      });
      this.trustFunds = [res.data];
    },
    async loadCoverageGroups() {
      let res;
      if (this.isPremiums) {
        res = await this.getInsuranceCarrierCoverageGroups({
          planId: this.plan.Id,
          reportId: this.reportId,
          insuranceCarrierIds: this.selected.InsuranceCarriers.map((o) => o.Id),
        });
      } else if (this.isBilling) {
        res = await this.getPlanCoverageGroups({
          planId: this.plan.Id,
          reportId: this.reportId,
        });
      } else if (this.isRemittances) {
        res = await this.getTrustfundCoverageGroups({
          planId: this.plan.Id,
          reportId: this.reportId,
        });
      }
      this.coverageGroups = res.data;
      this.coverageGroupItems = this.coverageGroups.map((cg) => {
        return { Name: cg };
      });
    },
    isReportType(type) {
      return this.reportType === type;
    },
    checkForValidReportSelection() {
      console.log("valid started");
      var selections = this.getReportsSelections();
      let valid = selections && selections.length > 0;
      if (this.coverageGroupItems.length > 0) {
        valid = valid && this.selected.CoverageGroups.length > 0;
      }

      for (const item of this.options) {
        switch (this.reportType) {
          case "Premiums":
            valid =
              item.IncludeMemberDetails ||
              item.IncludeGroupSummary ||
              item.IncludeTotal;
            break;
          case "Billing":
            if (item.EmployerId) {
              valid = item.EmployerHasStores
                ? item.IncludeTotal
                : item.IncludeMemberDetails || item.IncludeGroupSummary;
            } else if (item.StoreId) {
              valid = item.IncludeMemberDetails || item.IncludeGroupSummary;
            } else {
              valid = false;
            }
            break;
          case "Remittances":
            valid =
              item.IncludeMemberDetails ||
              item.IncludeGroupSummary ||
              item.IncludeTotal;
            break;
        }
        if (valid) {
          break;
        }
      }
      console.log("valid completed: ", valid);
      return valid;
    },
    getReportsSelections() {
      switch (this.reportType) {
        case "Premiums":
          return this.selected.InsuranceCarriers;
        case "Billing":
          return this.selected.Employers;
        case "Remittances":
          return this.selected.TrustFunds;
        default:
          return [];
      }
    },
  },
};
</script>

<style>
table.report-options td {
  padding: 10px;
}
</style>
